"use strict";

exports.__esModule = true;
exports.PlaybackPolicyHandler = void 0;
var _Session = require("./Session");
/*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
// JsDoc imports
/**
 * PlaybackPolicyHandler declares a set of methods that provide playback policy decisions to the app.
 *
 * It is implemented by a policy adapter; policy calls to PlaybackPolicy on the Session-derived instance
 * are delegated to this adapter.
 * @hideconstructor
 */
var PlaybackPolicyHandler = /*#__PURE__*/function () {
  function PlaybackPolicyHandler() {}
  var _proto = PlaybackPolicyHandler.prototype;
  /** Returns to the client whether playback can stop.
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @return {boolean} true if playback can stop, false otherwise.
   */
  _proto.canStop = function canStop(playhead, timeline) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client whether playback can pause.
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @return {boolean} true if playback can pause, false otherwise.
   */;
  _proto.canPause = function canPause(playhead, timeline) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client whether playback can skip.
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @param {number} duration The non-linear stream duration in milliseconds, or zero if the stream is live
   * @return {number} delay in seconds before the advert can be skipped, or -1 otherwise.
   */;
  _proto.canSkip = function canSkip(playhead, timeline, duration) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client the playhead position that the user can seek to.
   * @param {number} position the playhead position in milliseconds that the user wishes to seek to
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @param {number} playhead the playhead position in milliseconds that the user wishes to seek from
   * @return {number} the actual playhead position that the user can seek to, based on the implemented policy.
   */;
  _proto.willSeekTo = function willSeekTo(position, timeline, playhead) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client whether volume can be muted.
   * @param {boolean} mute The intended volume change: muted or unmuted
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @return {boolean} true if volume can be muted, false otherwise.
   */;
  _proto.canChangeVolume = function canChangeVolume(mute, playhead, timeline) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client whether full screen mode can change.
   * @param {boolean} fullScreen The target full screen mode
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @return {boolean} true if the player can go full screen, false otherwise.
   */;
  _proto.canResize = function canResize(fullScreen, playhead, timeline) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client whether the currently-displayed linear creative can be expanded.
   * Note that this method is not applicable to nonlinear creative.
   * 
   * @param {boolean} expand whether to expand the creative or collapse it
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @return {boolean} true if the linear creative can be expanded, false otherwise.
   */;
  _proto.canResizeCreative = function canResizeCreative(expand, playhead, timeline) {
    throw new Error("Must be overridden");
  }

  /** Returns to the client whether the user can click-through.
   * @param {string} url The click-through Url.
   * @param {number} playhead The current playhead position, in milliseconds
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   * @return {boolean} true if the user can click through, false otherwise.
   */;
  _proto.canClickThrough = function canClickThrough(url, playhead, timeline) {
    throw new Error("Must be overridden");
  }

  /** Sets the playback mode that the stream is running in. The policy handler implementation may
   * use this to modify the policy for specific requests, for example allowing pause in
   * Video-on-Demand but not live playback.
   * @param {PlaybackMode} mode the stream playback mode
   */;
  _proto.setPlaybackMode = function setPlaybackMode(mode) {
    throw new Error("Must be overridden");
  }

  /** Indicates that playback was skipped.
   * @param {number} from the playhead position in milliseconds prior to skipping
   * @param {number} to the playhead position in milliseconds after to skipping
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   */;
  _proto.didSkip = function didSkip(from, to, timeline) {
    throw new Error("Must be overridden");
  }

  /** Indicates that playback seeked.
   * @param {number} from the playhead position in milliseconds prior to seeking
   * @param {number} to the playhead position in milliseconds after to seeking
   * @param {Array} timeline The stream timeline represented as an array of AdBreak objects
   */;
  _proto.didSeek = function didSeek(from, to, timeline) {
    throw new Error("Must be overridden");
  };
  return PlaybackPolicyHandler;
}();
exports.PlaybackPolicyHandler = PlaybackPolicyHandler;